<span *ngFor="let item of showItems; let i = index"
  class="btn-container">
  <button mat-flat-button
    [ngClass]="selectedItem != item ? 'inactive':'active'"
    (click)="onClickItem(item)">
    {{ item[itemText] }}<br *ngIf="itemText2" />{{ item[itemText2] ? item[itemText2] : null }}
  </button>
</span>
